import { render, staticRenderFns } from "./LspLoadsContainer.vue?vue&type=template&id=a9487e8c&"
import script from "./LspLoadsContainer.vue?vue&type=script&lang=js&"
export * from "./LspLoadsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports